import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Empty, Modal, Spin } from "antd";
import { AddMerchantModal, SetFeesModel, SetMinWithdrawDepositModel } from "../../components/Model/add-model";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { QuestionCircleOutlined, PlusOutlined, } from "@ant-design/icons";
import { Table, Button } from "antd";
import { t } from "i18next";
import moment from "moment";
import AppContext from "../../components/AppContext";
import { CheckAdminType, CheckTypeAdmin } from "../../helpers/checkPermission";
import { withTranslation } from "react-i18next";
import { DOCTYPerrorMessage, hasPermission, showToast } from "../../utils";
import { DetailsMerchantModal } from "../../components/Model/index-model";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import Apisetting from "../../api/Apisetting";
import { ColumnsMerchant } from "../../components/Columns/columns-merchant";
const { confirm } = Modal;

class ManageMerchant extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      loadingSwitch: false,
      showModelAddMemerchang: false,
      showSetFeesModel: false,
      showSetMin_withdraw_deposit_Model: false,
      isData: null,
      dropdownPlacement: "bottomRight",
      showDetailsModel: false,
      isLoad: false,
      loadingTable: false,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
    };
    this.tableRef = React.createRef();
  }

  fetchData = async () => {
    try {
      await Promise.all([this.context.getAllDataMerchang()])
        .catch((error) => console.log("fetchData Promise Error:", error))
        .finally(() => this.setState({ loadingTable: false }));
    } catch (error) {
      console.log("Error fetching data:", error);
      showToast("error", t("Failed to fetch data."));
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.fetchData();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom =
        tableElement.getBoundingClientRect().bottom <= window.innerHeight;
      this.setState({
        dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight",
      });
    }
  };
  setLoading = (_loading) => this.setState({ isLoad: _loading });
  handleShowModelAddMemerchang = () => this.setState({ showModelAddMemerchang: true });
  handleShowModelSetFeesModel = (o) => {
    if (!o) return;
    this.setState({ showSetFeesModel: true, isData: o });
  };

  handleShowSetMin_withdraw_deposit_Model = (o) => {
    if (!o) return;
    this.setState({ showSetMin_withdraw_deposit_Model: true, isData: o });
  };

  handleClose = () => {
    this.setState({
      show: false,
      showModelAddMemerchang: false,
      showSetFeesModel: false,
      showDetailsModel: false,
      showSetMin_withdraw_deposit_Model: false,
      isData: null
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      loadingTable: true,
      tableParams: {
        pagination,
        filters,
        sortField: sorter.field,
        sortOrder: sorter.order,
      },
    }, () => this.fetchData());
  };

  handleShowDetailsModel = (item) => {
    if (!item || !item.id) return showToast("error", "ไม่พบข้อมูล");
    this.setState({ showDetailsModel: true, isData: item });
  };

  handleConfirmOk = async (item, newStatus, type) => {
    this.setState({ isLoad: true });

    let d = {
      isActive: newStatus ? 1 : 0,
    };
    try {
      let res;
      if (type === "status") {
        res = await Apisetting.updateMerchantStatusAPI(d);
      } else if (type === "del") {
        if (!item?.FeeSetting?.id) {
          showToast("error", "ข้อมูลไม่ถูกต้อง");
          this.setState({ isLoad: false });
          return;
        }
        res = await Apisetting.postRemoveMerchantAPI({ merchantId: item?.FeeSetting?.id, deleted_at: moment().format() });
      } else {
        showToast("warning", "!มีบางอย่างไม่ถูกต้อง");
        this.setState({ isLoad: false });
        return;
      }

      if (res.data.success) {
        let isType = type === "status" ? "Status updated successfully." : "Remove successfully.";
        showToast("success", t(isType));
        setTimeout(() => {
          this.setState({ loadingSwitch: false, isLoad: false }, () => this.context.getAllDataMerchang());
        }, 1000);
      } else {
        this.setState({ loadingSwitch: false, isLoad: false });
        showToast("error", res.data.message || "Failed to fetch all merchant data.",);
      }
    } catch (error) {
      console.error("Error:", error);
      this.setState({ loadingSwitch: false, isLoad: false });
      const errorMsg = JSON.stringify(error?.response?.data) || error?.message || "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้";

      if (error.status === 404) {
        showToast("error", `${DOCTYPerrorMessage(errorMsg) || "N/A"}`);
      } else {
        showToast("error", `${errorMsg || "N/A"}`);
      }
    }
  };

  handleConfirmCancel = () => {
    showToast("info", t("การเปลี่ยนแปลงสถานะถูกยกเลิก"));
    this.setState({ loadingSwitch: false });
  };

  showConfirm = (item, newStatus, type) => {
    const isStatus = type === "status";
    const okText = isStatus ? (newStatus ? t("เปิดใช้งาน") : t("ระงับการใช้งาน")) : t("ลบร้านค้า");
    const title = isStatus ? t("คุณต้องการเปลี่ยนสถานะใช่ไหม?") : t("คุณต้องการลบร้านค้าใช่ไหม?");

    confirm({
      title,
      icon: <QuestionCircleOutlined />,
      okText,
      cancelText: t("Cancel"),
      content: (
        <div>
          {t("คุณแน่ใจใช่ไหมที่จะ")} {okText} <b>{item.name}</b>?
        </div>
      ),
      onOk: () => this.handleConfirmOk(item, newStatus, type),
      onCancel: () => this.setState({ loadingSwitch: false }),
    });
  };

  onChangeStatus = (checked, item, type) => this.setState({ loadingSwitch: true }, () => this.showConfirm(item, checked, type));

  render() {
    // const { isInbox } = this.props;
    const {
      resAllDataMerchang,
      tokenMerchant,
      loadingCustomers,
      resProfileAdmin,
      permissionData
    } = this.context;

    let merchantArray = Array.isArray(resAllDataMerchang) ? resAllDataMerchang : [];
    const {
      activeTabKey1,
      isData,
      showSetFeesModel,
      tableParams,
      showModelAddMemerchang,
      showSetMin_withdraw_deposit_Model,
      showDetailsModel,
      loadingSwitch,
      dropdownPlacement,
      loadingTable,
    } = this.state;
    const setActiveTabKey1 = (key) => this.setState({ activeTabKey1: key });

    const onTab1Change = (key) => setActiveTabKey1(key);

    const tabList = [
      {
        key: "tab1",
        tab: t("merchantInfo"),
      },
    ];
    let admin_type = CheckTypeAdmin(resProfileAdmin);
    let idMerchant = localStorage.getItem("selectedID");

    const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];

    const accessible_details = hasPermission(userPermissions, "details_merchant"); // details

    const accessible_setup = hasPermission(userPermissions, "setup_merchant");  // details

    const columns = ColumnsMerchant(
      accessible_details,
      accessible_setup,
      t,
      FormatTimeAgo,
      CheckAdminType,
      idMerchant,
      loadingSwitch,
      this.onChangeStatus,
      this.handleShowDetailsModel,
      this.handleShowModelSetFeesModel,
      this.handleShowSetMin_withdraw_deposit_Model,
      admin_type,
      dropdownPlacement
    );

    // Table
    const contentList = {
      tab1: (
        <div className="body table-responsive">
          <Table
            className="col-lg-12"
            columns={columns}
            rowKey={(record) => record.id}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t("No data")}
                />
              ),
            }}
            onChange={this.handleTableChange}
            dataSource={merchantArray}
            loading={loadingCustomers || loadingTable}
            pagination={{
              ...tableParams.pagination,
              showSizeChanger: true,
              locale: {
                items_per_page: `/ ${t("paged")}`,
              },
              showTotal: (total, range) => {
                // คำนวณหน้าปัจจุบัน
                const currentPage = tableParams.pagination.current;
                // คำนวณจำนวนหน้าทั้งหมด
                const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                return (
                  <span>
                    {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                    <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                    <span style={{ marginLeft: 10 }}>
                      {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                    </span>
                  </span>
                );
              },
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      ),
    };
    return (
      <>
        {/* Modal Components */}
        <AddMerchantModal
          handleClose={this.handleClose}
          getAllDataMerchang={this.context.getAllDataMerchang}
          show={showModelAddMemerchang}
          tokenMerchant={tokenMerchant}
          t={t}
          permissionData={permissionData}
        />
        <DetailsMerchantModal
          handleClose={this.handleClose}
          show={showDetailsModel}
          isData={isData}
          t={t}
        />
        <SetFeesModel
          handleClose={this.handleClose}
          isData={isData}
          show={showSetFeesModel}
          getAllDataMerchang={this.context.getAllDataMerchang}
          resAllMerchangdata={merchantArray}
          t={t}
        />
        <SetMinWithdrawDepositModel
          handleClose={this.handleClose}
          isData={isData}
          show={showSetMin_withdraw_deposit_Model}
          getAllDataMerchang={this.context.getAllDataMerchang}
          t={t}
        />
        <Spin spinning={false}>
          <div style={{ flex: 1 }}>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("manage merchant")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
            <br className="sm-hiden" />
            <Card
                title={
                  CheckAdminType("addmerchant") && (
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => this.setState({ showModelAddMemerchang: true })}
                    >
                      {t("add")}
                    </Button>
                  )
                }
                extra={null}
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={onTab1Change}
              >
                {contentList[activeTabKey1]}
              </Card>
            </div>
          </div>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(ManageMerchant));
